module.exports = __webpack_public_path__ + "img/404-image.36797a63.png";